<template lang="pug">
  #app
    page-header(
      :cids="cids",
      :isLogin="loginSys.isLogin",
      :userName="userInfo.name"
    )

    transition(enter-active-class="animated fadeIn")
      router-view

    page-footer

    el-dialog(
      custom-class="dialog-login",
      :visible.sync="dialogTableVisible",
      @close="dialogLoginClose"
    )
      login(v-if="loginSys.stat === 'login'")
      signup(v-if="loginSys.stat === 'signup'")
</template>

<script>
import Vue from 'vue'
import { Dialog } from 'element-ui'

Vue.use(Dialog)

import pageHeader from '@/components/Header'
import pageFooter from '@/components/Footer'
import { login, signup, signupSuccess } from '@/components/loginPanel'
import * as cookies from "js-cookie";

export default {
  name: 'app',
  data () {
    return {
      dialogTableVisible: false,

      cids: [],
      loginSys: {
        isLogin: false,
        stat: '',
        loading: false
      },
      userInfo: {
        name: cookies.get('fb_name')?cookies.get('fb_name'):'',
        account: '',
        password: ''
      }
    }
  },
  watch: {
    loginSys: {
      deep: true,
      handler: function (val, oldVal) {
      }
    }
  },
  created () {
    this.$bus.on('getCids', cids => (this.cids = cids))
    this.$bus.on('getLoginStat', stat => {
      this.loginSys.stat = stat
      this.dialogTableVisible = stat.length > 0
    })
    this.$bus.on('getUserInfo', info => {
      this.userInfo.name = info.name
      this.userInfo.account = info.account

      this.loginSys.isLogin = true
    })
    this.$bus.on('logout', stat => {
      if (stat === true) {
        this.userInfo.anme = ''
        this.userInfo.account = ''

        this.loginSys.isLogin = false
      }else{
        this.loginSys.isLogin = true
      }
    })
  },
  methods: {
    dialogLoginClose () {
      this.loginSys.stat = ''
    }
  },
  components: {
    pageHeader,
    pageFooter,
    login,
    signup,
    signupSuccess
  }
}
</script>

<style lang="stylus">
html body
  font-size 14px
  font-family Roboto,Arial,Helvetica,sans-serif
  .dialog-login
    width 25%
    min-width 480px
    max-width 600px
</style>



// WEBPACK FOOTER //
// App.vue?3f2f6b89